export default function RedemptionLinks() {
  return (
    <div className="box">
      <h1>Redemption links page placeholder</h1>
    </div>
  );
}
